import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { usePaymentsContext } from '../store/payments';
import { resetPaymentState } from '../store/paymentsReducer';

const isObjectEmpty = (obj?: object): boolean => {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

const useClearPaymentContext = () => {
  const { dispatch, state } = usePaymentsContext();
  const location = useLocation();

  useEffect(() => {
    const hasSelectedPayments =
      !isObjectEmpty(state.selectedBill) ||
      !isObjectEmpty(state.selectedPayments) ||
      !isObjectEmpty(state.singleSelectedPayment);

    const hasSelectedPaymentMethod = !isObjectEmpty(
      state.selectedPaymentMethod
    );

    const paymentContextClearable =
      hasSelectedPayments || hasSelectedPaymentMethod;

    const userOnPaymentRoute =
      location.pathname.includes('payment') ||
      location.pathname.includes('autopay');

    if (paymentContextClearable && !userOnPaymentRoute) {
      dispatch(resetPaymentState());
    }
  }, [location]);
};

export default useClearPaymentContext;
